import React from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

import './Footer.scss'

function Footer() {
    return (
        <footer className="main-footer">
            <div className="footer-menu">
                <Container>
                    <Nav className="justify-content-center">
                        <Nav.Item><Nav.Link as={Link} smooth to="/#about">Об олимпиаде</Nav.Link></Nav.Item>
                        <Nav.Item><Nav.Link as={Link} smooth to="/#documents">Документы</Nav.Link></Nav.Item>
                        <Nav.Item><Nav.Link as={Link} smooth to="/#dates">Сроки проведения</Nav.Link></Nav.Item>
                        <Nav.Item><Nav.Link as={Link} smooth to="/#materials">Материалы для подготовки</Nav.Link></Nav.Item>
                        <Nav.Item><Nav.Link as={Link} smooth to="/gallery">Выставка</Nav.Link></Nav.Item>
                    </Nav>
                </Container>
            </div>

            <div className="footer-content-block">
                <Container>
                    <Row className="footer-main-row gy-4 lg-gy-0 position-relative">
                        <Col xs={12} lg={5} className="footer-left">
                            <h5 className="text">Организатор</h5>
                            <div className="footer-logo-container">
                                <a href={'https://cic-edu.ru'}>
                                    <div className="footer-logo"></div>
                                </a>
                            </div>
                            <div className="footer-contacts">
                                <div className="contact-row">
                                    <i className="icon-location contact-icon" />
                                    <div>г. Москва, Большая Серпуховская ул.,<br />д. 25 стр. 14, 115093</div>
                                </div>
                                <div className="contact-row contact-row-center">
                                    <i className="icon-phone contact-icon" />
                                    <div>8(495) 911-61-11</div>
                                </div>
                                <div className="contact-row contact-row-center social-contact-row">
                                    <i className="icon-mail contact-icon" />
                                    <div>info@cic-edu.ru</div>
                                    <div className="social">
                                        <a href="https://vk.com/cms.project" target="_blank" rel="noreferrer"><div className="social-button social-button-first social-vk"></div></a>
                                        <a href="https://t.me/cms_project" target="_blank" rel="noreferrer"><div className="social-button social-tg"></div></a>
                                        <a href="https://max.ru/id3702068020_gos" target="_blank" rel="noreferrer"><div className="social-button social-max"></div></a>
                                        <a href="https://dzen.ru/id/6a33bc6ed1d4505f735dbd75?share_to=link" target="_blank" rel="noreferrer"><div className="social-button social-zen"></div></a>
                                        <a href="https://rutube.ru/channel/77870310/" target="_blank" rel="noreferrer"><div className="social-button social-rutube"></div></a>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col xs={12} lg={7} className="footer-right">
                            <div className="right-top">
                                <h5 className="text">Контакты</h5>
                                <div className="contact-row contact-row-center">
                                    <i className="icon-mail icon-mail-bigger contact-icon" />
                                    <a href="mailto:dalolymp@cic-edu.ru">
                                        <h5 className="m-0 text-email">dalolymp@cic-edu.ru</h5>
                                    </a>
                                </div>
                            </div>
                            <div className="right-bottom">
                                <div className="footer-mplogo-container">
                                    <a href="https://edu.gov.ru" target="_blank" rel="noreferrer">
                                        <div className="footer-mplogo"></div>
                                    </a>
                                </div>
                                <div className="copyright">
                                    &copy; 2023 - {new Date().getFullYear()}, ФГБОУ ЦМС Минпросвещения России
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </footer>
    );
}

export default Footer;
